<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师上课记录</Breadcrumb-item>
        <Breadcrumb-item>新签学生列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="16" :md="10" >
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="课程类型" :label-width="75">
            <Select v-model.number="queryParam.lsnType" placeholder="全部"
                    @on-change="search" clearable>
              <Option v-for="item in $constant.bookLessonOpenedLsnType"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="4">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bc/listNewAssign"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        searchLoading: false,
        exportLoading: false,
        reload: 0,
        queryParam: {
          tchId: '',
          uid: '',
          userNickname: '',
          adminNickname: '',
          lessonStartTime: '',
          lessonEndTime: '',
          lsnType: '',
        },
        title: [
          {
            title: '学生姓名/ID',
            render: (h, params) => {
              let row = params.row
              return h('span', row.nickName + '-' + row.uid)
            }
          },
          {
            title: '试听课名称',
            key: 'trailLessonName',
          },
          {
            title: '试听课时间',
            key: 'trailTimeStr',
          },
          {
            title: '初节常规课',
            key: 'routineName'
          },
          {
            title: '初节常规课时间',
            key: 'routineTimeStr',
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
      this.queryParam.tchId = localStorage.tchId
      this.queryParam.lessonStartTime = localStorage.startTime
      this.queryParam.lessonEndTime = localStorage.endTime
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
    }
  }

</script>



// WEBPACK FOOTER //
// NewAssignDetail.vue?2e70ad98